import React from "react";
import Overlay from "../../Overlay";

//style
import "../../../styles/allWorkExchangeModal.scss";

function ImagePopup({ onClose, image }) {
  function handleConfirm() {
    onClose();
  }

  return (
    <Overlay
      className="image-popup"
      style={{
        alignItems: "flex-start",
      }}
      onClose={onClose}
      content={
        <div className="image-container">
          <div className="image-container-content">
            <img src={image} />
          </div>
        </div>
      }
    ></Overlay>
  );
}

ImagePopup.propTypes = {};

export default ImagePopup;
